import { jsx, jsxs } from 'react/jsx-runtime';
import { useElementFilter } from '@backstage/core-plugin-api';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  value: {
    fontWeight: "bold",
    overflow: "hidden",
    lineHeight: "24px",
    wordBreak: "break-word"
  },
  label: {
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    fontSize: "10px",
    fontWeight: "bold",
    letterSpacing: 0.5,
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
}));
function AboutField(props) {
  const { label, value, gridSizes, children, className } = props;
  const classes = useStyles();
  const childElements = useElementFilter(children, (c) => c.getElements());
  const content = childElements.length > 0 ? childElements : /* @__PURE__ */ jsx(Typography, { variant: "body2", className: classes.value, children: value || `unknown` });
  return /* @__PURE__ */ jsxs(Grid, { item: true, ...gridSizes, className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "h2", className: classes.label, children: label }),
    content
  ] });
}

export { AboutField };
//# sourceMappingURL=AboutField.esm.js.map
